import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class ReorderLevelService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  getAll(): Observable<ApiResponse> {
    let apiURL:string=`${this.baseURL}/v1/reorder-levels`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  create(formData: any): Observable<ApiResponse> {
    let apiURL:string=`${this.baseURL}/v1/reorder-levels`;

    return this.http.post<ApiResponse>(apiURL, formData,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  update(id: number, formData: any): Observable<ApiResponse> {
    let apiURL:string=`${this.baseURL}/v1/reorder-levels`;

    return this.http.put<ApiResponse>(`${apiURL}/${id}`, formData,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  delete(id: number): Observable<ApiResponse> {
    let apiURL:string=`${this.baseURL}/v1/reorder-levels`;

    return this.http.delete<ApiResponse>(`${apiURL}/${id}`).pipe(catchError(this.errorHandler.handleError));
  }
}
